export default "__VITE_ASSET__gZiUrE$P__"